import { render, staticRenderFns } from "./WspFooter.vue?vue&type=template&id=6d5b23b6"
import script from "./WspFooter.vue?vue&type=script&lang=js"
export * from "./WspFooter.vue?vue&type=script&lang=js"
import style0 from "./WspFooter.vue?vue&type=style&index=0&id=6d5b23b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports